export default __webpack_public_path__ + "assets/models/afe3ca786974cd1ab4c4f50e52e97063.gltf";